// src/components/Pagamentos/RelatorioReferencias.js
import React from "react";

const RelatorioReferencias = ({ aluno, pagamentos = [], onClose }) => {
  if (!aluno) return null;

  return (
    <div style={{ padding: "20px", border: "1px solid #ccc", background: "#fff" }}>
      <h2>Relatório de Pagamentos (Teste)</h2>
      <p><strong>Aluno:</strong> {aluno.nome}</p>

      <table border="1" cellPadding="8" cellSpacing="0">
        <thead>
          <tr>
            <th>Data</th>
            <th>Valor</th>
            <th>Referência</th>
          </tr>
        </thead>
        <tbody>
          {pagamentos.map((pagamento, index) => (
            <tr key={pagamento.id || index}>
              <td>{pagamento.data || "—"}</td>
              <td>{pagamento.valor || "—"}</td>
              <td>{pagamento.referencia || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button onClick={onClose} style={{ marginTop: "10px" }}>Fechar</button>
    </div>
  );
};

export default RelatorioReferencias;
